import Menu from 'Models/Menu';

export default [
  Menu.userInformation,
  Menu.createNewUser,
  Menu.usersHelp,
];
